export const GET_SEARCH_BY_TEXT_PENDING = "GET_SEARCH_BY_TEXT_PENDING";
export const GET_SEARCH_BY_TEXT_FULFILLED = "GET_SEARCH_BY_TEXT_FULFILLED";
export const GET_SEARCH_BY_TEXT_REJECTED = "GET_SEARCH_BY_TEXT_REJECTED";
